export default {
    setCollectivites: (state, collectivites) => {
        state.collectivites = collectivites;
    },
    setCollectivite: (state, data) => {
        if (data) {
            state.collectivite = data.collectivite;
            state.tarifs = data.tarifs;
            state.options = data.options;
            state.parametres_tlpe = data.parametres_tlpe;
            state.dossier = data.dossier;
        } else {
            state.collectivite = null;
            state.tarifs = [];
            state.options = [];
            state.parametres_tlpe = [];
            state.dossier = null;
        }
    },
    setTarifsUsed: (state, tarifsUsed) => {
        state.tarifsUsed = tarifsUsed;
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/Collectivite/mutations.js